import type { CustomClaim } from ".";

export type UserClaim = {
  name: string | null;
  claims?: CustomClaim[];
};

export const MSFT_ROLE_CLAIM_TYPE =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
